import { QueryClient } from "@tanstack/vue-query";

// instância única: o SessionClientAdapter limpa o cache ao encerrar a sessão,
// para um usuário não ver (nem por um instante) os dados do anterior na mesma aba
export const queryClient = new QueryClient();
